// init fancybox
function initFancybox() {
	Fancybox.bind("[data-fancybox]", {
		autoFocus: false,
		dragToClose: false,
		placeFocusBack: false,
	});
}

// Initialize all sliders
function initSliders() {

	const instagramSwiper = document.querySelector('.instagram-swiper');

	if (instagramSwiper) {
    const swiperInstance = new Swiper(instagramSwiper, {
      spaceBetween: 20,
      loop: true,
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      slidesPerView: 1.3,
      allowTouchMove: false,
      grabCursor: false,
      breakpoints: {
        575: { slidesPerView: 2.2 },
        767: { slidesPerView: 3 },
        992: { slidesPerView: 4 },
        1400: { slidesPerView: 5 },
      },
    });
	}

  const blogHomeSwiper = document.querySelector('.blog-home-slider');

	if (blogHomeSwiper) {
    const slider = new Swiper(blogHomeSwiper, {
      spaceBetween: 20,
      loop: false,
      slidesPerView: 1.1,
      allowTouchMove: true,
      navigation: {
        nextEl: '.blog-home-slider-nav .next',
        prevEl: '.blog-home-slider-nav .prev',
      },
      breakpoints: {
        767: { slidesPerView: 2.2 },
        1200: { slidesPerView: 3 }
      },
    });
	}

  const homeBannerSwiper = document.querySelector('.home-banner-slider');

	if (homeBannerSwiper) {
    const slider = new Swiper(homeBannerSwiper, {
      effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
      loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			allowTouchMove: false,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false
			},
			pagination: {
				el: '.home-banner-slider-pagination',
				clickable: true
			}
    })
	}
}

// Initialize Mobile Menu
function initMobileMenu() {
  'use strict';
  
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  const fsMenu = document.getElementById('fs-menu');
  const menuOverlay = document.getElementById('menu-overlay');
  
  if (!fsMenu || !menuOverlay) {
    return;
  }
  
  let isFsMenuOpen = false;
  
  // Open Mobile Menu
  function openFsMenu() {
    if (fsMenu && menuOverlay) {
      isFsMenuOpen = true;
      fsMenu.classList.remove('visibility-hidden', 'pointer-events-none');
      fsMenu.classList.add('!translate-x-0', '!opacity-100', '!pointer-events-auto');
      fsMenu.style.opacity = '1';
      menuOverlay.classList.add('!pointer-events-auto', 'opacity-30');
      document.body.style.overflow = 'hidden';
    }
  }
  
  // Close Mobile Menu
  function closeFsMenu() {
    if (fsMenu && menuOverlay) {
      isFsMenuOpen = false;
      fsMenu.classList.add('visibility-hidden', 'pointer-events-none');
      fsMenu.classList.remove('!translate-x-0', '!opacity-100', '!pointer-events-auto');
      fsMenu.style.opacity = '0';
      menuOverlay.classList.remove('!pointer-events-auto', 'opacity-30');
      document.body.style.overflow = '';
    }
  }
  
  // Close All (only closes mobile menu, cart drawer has its own handler)
  function closeAll() {
    closeFsMenu();
  }
  
  // Event Listeners
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openFsMenu);
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeFsMenu);
  }
  
  if (menuOverlay) {
    menuOverlay.addEventListener('click', closeAll);
  }
  
  // Close on ESC key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && isFsMenuOpen) {
      closeAll();
    }
  });
  
  // Close menu when clicking on links
  const fsMenuLinks = fsMenu.querySelectorAll('a');
  if (fsMenuLinks) {
    fsMenuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        closeFsMenu();
      });
    });
  }
}

// Initialize Cart Drawer
function initCartDrawer() {
  'use strict';
  
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerClose = document.querySelector('[data-cart-drawer-close]');
  const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  const cartIcon = document.getElementById('cart-icon-link');

  if (!cartDrawer || !cartDrawerOverlay) {
    return;
  }

  let isCartOpen = false;

  // Open Cart Drawer -
  function openCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      isCartOpen = true;
      
      // Fetch latest cart data
      fetchCart();
      
      // Remove hide classes
      cartDrawer.classList.remove('visibility-hidden', 'pointer-events-none');
      // Add show classes
      cartDrawer.classList.add('!translate-x-0', '!opacity-100', '!pointer-events-auto');
      cartDrawer.style.opacity = '1';
      // Activate overlay
      cartDrawerOverlay.classList.add('!pointer-events-auto', 'opacity-30');
      cartDrawerOverlay.style.opacity = '0.3';
      // Lock body scroll
      document.body.style.overflow = 'hidden';
    }
  }

  // Close Cart Drawer - Based on Next.js behavior
  function closeCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      isCartOpen = false;
      // Add hide classes
      cartDrawer.classList.add('visibility-hidden', 'pointer-events-none');
      // Remove show classes
      cartDrawer.classList.remove('!translate-x-0', '!opacity-100', '!pointer-events-auto');
      cartDrawer.style.opacity = '0';
      // Deactivate overlay
      cartDrawerOverlay.classList.remove('!pointer-events-auto', 'opacity-30');
      cartDrawerOverlay.style.opacity = '0';
      // Unlock body scroll
      document.body.style.overflow = '';
    }
  }

  // Format money - Helper function
  function formatMoney(cents, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(cents / 100);
  }

  // Render cart item HTML
  function renderCartItem(item) {
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' 
      ? `<p class="text-12 text-gray-medium leading-[1.2]">${escapeHtml(item.variant_title)}</p>` 
      : '';
    
    const imageHtml = item.image 
      ? `<a href="${escapeHtml(item.url)}" class="relative block h-auto min-h-18 w-18 rounded-[.125rem] border border-gray-lighter bg-white sm:min-h-20 sm:w-20">
          <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" width="80" height="80" class="cover" loading="lazy">
        </a>`
      : '';

    const newQuantity = item.quantity;
    const decreaseQuantity = Math.max(0, newQuantity - 1);
    const increaseQuantity = newQuantity + 1;

    return `
      <div class="relative flex items-center justify-start gap-4 rounded-[.25rem] border border-gray-light bg-pure-white p-2 xl:p-3" data-cart-item-key="${escapeHtml(item.key)}">
        
        ${imageHtml}

        <div class="flex-1">
          <a href="${escapeHtml(item.url)}" class="font-semibold text-16 hover:text-green-dark">${escapeHtml(item.product_title)}</a>
          ${variantTitle}
          <div class="relative flex flex-wrap gap-2">
            <p class="bold product-price flex items-center gap-2" data-item-price="${escapeHtml(item.key)}">${formatMoney(item.final_line_price, item.currency)}</p>
            <div class="relative block w-24">
              <button type="button" class="decrease medium absolute top-[50%] left-1 z-3 flex h-6 w-6 translate-y-[-50%] items-center justify-center disabled:opacity-50" data-cart-update data-line="${escapeHtml(item.key)}" data-quantity="${decreaseQuantity}">-</button>
              <span class="no-spinner flex items-center justify-center h-9 w-full rounded-[.175rem] border border-gray-light bg-transparent text-center text-14 leading-[1.2] disabled:opacity-50" data-item-quantity="${escapeHtml(item.key)}">${newQuantity}</span>
              <button type="button" class="increase medium absolute top-[50%] right-1 z-3 flex h-6 w-6 translate-y-[-50%] items-center justify-center disabled:opacity-50" data-cart-update data-line="${escapeHtml(item.key)}" data-quantity="${increaseQuantity}">+</button>
            </div>
          </div>
        </div>

        <button type="button" class="absolute top-0 right-0 flex h-[.75rem] w-[.75rem] items-center justify-center transition-color duration-300 ease-in-out hover:text-red focus-visible:text-red sm:top-1 sm:right-1" data-cart-remove data-line="${escapeHtml(item.key)}">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 18" class="h-full w-full"><path d="M15.031 2.813c.457 0 .844.386.844.843a.833.833 0 0 1-.844.844h-.422l-.843 11.426C13.66 17.12 12.71 18 11.516 18H4.449c-1.195 0-2.144-.879-2.25-2.074L1.355 4.5H.97c-.492 0-.844-.352-.844-.844 0-.457.352-.844.844-.844h2.426L4.695.88A2.02 2.02 0 0 1 6.348 0h3.27c.667 0 1.3.352 1.652.879l1.3 1.934zM6.348 1.687c-.106 0-.211.07-.246.141l-.668.984h5.097l-.668-.984a.3.3 0 0 0-.246-.14zM12.922 4.5H3.043l.844 11.32a.57.57 0 0 0 .562.492h7.067c.28 0 .527-.21.562-.492z"></path></svg>
        </button>

      </div>
    `;
  }

  // Escape HTML to prevent XSS
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Cart Item Template
  const cartItem = `
    <div class='relative flex items-center justify-start gap-4 rounded-[.25rem] border border-gray-light bg-pure-white p-2 xl:p-3' data-cart-item-key='%CART_KEY%'>
      <div class='relative flex w-full gap-3 xl:gap-4'>
        <a href='%PRODUCT_URL%' class='relative block h-auto min-h-18 w-18 rounded-[.125rem] border border-gray-lighter bg-white sm:min-h-20 sm:w-20'>
          <img 
            src='%PRODUCT_IMAGE%' 
            alt='%PRODUCT_TITLE%'
            width='80'
            height='80'
            class='cover'
            loading='lazy'
          >
        </a>

        <div class='flex flex-col pr-6 sm:gap-1 w-full'>
          <a href='%PRODUCT_URL%' class='product-name mb-1 sm:mb-0 block text-14 leading-[1.2]'>
            %PRODUCT_TITLE%
            %BOGO_BADGE%
          </a>

          %VARIANT_TITLE%

          <div class="relative flex mt-1 sm:mt-0 sm:justify-between sm:items-end w-[calc(100%+1.5rem)] gap-2 pr-[5.5rem] sm:pr-0">

            <div class='flex flex-col gap-1'>

              <p class='bold product-price flex items-center gap-2'>
                <span class='%PRICE_CLASS%'>%PRODUCT_PRICE%</span>
              </p>
              
              %DISCOUNT_BADGE%
              
              %SELLING_PLAN_TEXT%

            </div>

            <div class='absolute sm:relative bottom-0 right-0 sm:bottom-auto sm:right-auto w-[5.5rem] sm:w-24 block %QUANTITY_DISABLED%'>
              %QUANTITY_BUTTONS%
              <span class='no-spinner flex items-center justify-center h-9 w-full rounded-[.175rem] border border-gray-light bg-transparent text-center text-14 leading-[1.2] disabled:opacity-50 pointer-events-none %QUANTITY_OPACITY%' id='quantity-%CART_KEY%'>%QUANTITY%</span>
            </div>

            %PRODUCT_PLAN%

          </div>
        </div>

        <button 
          type='button' 
          class='absolute top-0 right-0 flex h-[.75rem] w-[.75rem] items-center justify-center transition-color duration-300 ease-in-out hover:text-red focus-visible:text-red sm:top-1 sm:right-1'
          onclick='changeItem(%PRODUCT_ID%, 0, %PRODUCT_PLAN_ID%)'
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 18" class="h-full w-full"><path d="M15.031 2.813c.457 0 .844.386.844.843a.833.833 0 0 1-.844.844h-.422l-.843 11.426C13.66 17.12 12.71 18 11.516 18H4.449c-1.195 0-2.144-.879-2.25-2.074L1.355 4.5H.97c-.492 0-.844-.352-.844-.844 0-.457.352-.844.844-.844h2.426L4.695.88A2.02 2.02 0 0 1 6.348 0h3.27c.667 0 1.3.352 1.652.879l1.3 1.934zM6.348 1.687c-.106 0-.211.07-.246.141l-.668.984h5.097l-.668-.984a.3.3 0 0 0-.246-.14zM12.922 4.5H3.043l.844 11.32a.57.57 0 0 0 .562.492h7.067c.28 0 .527-.21.562-.492z"></path></svg>
        </button>

      </div>
    </div>
  `;

  // Helper function to replace all occurrences
  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  // Format money helper
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Open Cart
  function openCart() {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-drawer-overlay');
    
    if (!cartDrawer || !cartOverlay) return;

    // Fetch latest cart data
    fetchCart();

    // Show cart drawer
    cartDrawer.style.opacity = '1';
    cartDrawer.classList.remove('visibility-hidden', 'pointer-events-none');
    cartDrawer.classList.remove('translate-x-[110%]');
    cartDrawer.classList.add('translate-x-0');
    
    // Show overlay
    cartOverlay.classList.remove('pointer-events-none');
    cartOverlay.style.opacity = '0.5';
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  // Close Cart
  function closeCart() {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-drawer-overlay');
    
    if (!cartDrawer || !cartOverlay) return;

    // Hide cart drawer
    cartDrawer.classList.add('translate-x-[110%]');
    cartDrawer.classList.remove('translate-x-0');
    
    // Hide overlay
    cartOverlay.style.opacity = '0';
    
    setTimeout(() => {
      cartDrawer.style.opacity = '0';
      cartDrawer.classList.add('visibility-hidden', 'pointer-events-none');
      cartOverlay.classList.add('pointer-events-none');
    }, 300);
    
    // Restore body scroll
    document.body.style.overflow = '';
  }

  // Fetch Cart
  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  // Render Cart
  function renderCart(cart) {
    const cartItemHolder = document.getElementById('cart-items-container');
    if (!cartItemHolder) return;

    cartItemHolder.innerHTML = '';

    if (cart.items.length === 0) {
      cartItemHolder.innerHTML = '<p class="text-14">Your cart is empty.</p>';
      
      // Update checkout button
      const checkoutButton = document.querySelector('[name="checkout"]');
      if (checkoutButton) {
        checkoutButton.disabled = true;
      }
    } else {
      // Render each cart item
      cart.items.forEach((item) => {
        const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id || null;
        const sellingPlanName = item.selling_plan_allocation?.selling_plan?.name || '';
        const cartKey = item.key || (item.id + '-' + (sellingPlanId || 'onetime'));
        
        // Check if item is BOGO (free item)
        const isBOGO = item.final_line_price === 0;
        
        let cartItemHTML = replaceAll(cartItem, '%PRODUCT_TITLE%', item.product_title);
        cartItemHTML = replaceAll(cartItemHTML, '%QUANTITY%', item.quantity);
        cartItemHTML = replaceAll(cartItemHTML, '%CART_KEY%', cartKey);
        cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_IMAGE%', item.image ? item.image.replace('.png', '_200x.png').replace('.jpg', '_200x.jpg') : '');
        cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_URL%', item.url);
        
        // BOGO Badge
        const bogoBadge = isBOGO 
          ? `<span class="ml-1 inline-block rounded-[.1rem] bg-gray-400 -translate-y-px px-1 py-[.1rem] text-[.75em] text-white leading-none">BOGO</span>` 
          : '';
        cartItemHTML = replaceAll(cartItemHTML, '%BOGO_BADGE%', bogoBadge);
        
        // Price formatting
        const price = formatMoney(item.final_line_price);
        const hasDiscount = item.original_line_price > item.final_line_price;
        const discountAmount = hasDiscount ? (item.original_line_price - item.final_line_price) : 0;
        
        cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_PRICE%', price);
        cartItemHTML = replaceAll(cartItemHTML, '%PRICE_CLASS%', '');
        
        // Discount Badge (new format)
        let discountBadge = '';
        if (hasDiscount && discountAmount > 0) {
          discountBadge = `<p class="flex items-center gap-1 text-12 text-gray-medium leading-[1.2]">
            <span>
              <svg class="relative top-[-1px] inline-block h-3 w-3" viewBox="0 0 12 12">
                <title>Discount</title>
                <path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path>
              </svg>
              BFCM BOGO
            </span>
            <span>(-${formatMoney(discountAmount)})</span>
          </p>`;
        }
        cartItemHTML = replaceAll(cartItemHTML, '%DISCOUNT_BADGE%', discountBadge);
        
        // Selling Plan Text (below price) - dynamic with plan name and discount
        let sellingPlanText = '';
        if (sellingPlanName) {
          // Calculate discount percentage if there's a price difference
          let discountText = '';
          if (item.original_line_price > item.final_line_price && item.original_line_price > 0) {
            const discountPercent = Math.round(((item.original_line_price - item.final_line_price) / item.original_line_price) * 100);
            discountText = ` · Save ${discountPercent}%`;
          }
          sellingPlanText = `<p class="medium mb-1 text-12 text-gray-medium leading-[1.2]">${sellingPlanName}${discountText}</p>`;
        }
        cartItemHTML = replaceAll(cartItemHTML, '%SELLING_PLAN_TEXT%', sellingPlanText);
        
        // Quantity controls - hide buttons for BOGO items
        // Get values for placeholders first
        const productId = item.id;
        const quantity = item.quantity;
        const planId = sellingPlanId || 'null';
        
        let quantityButtons = '';
        if (!isBOGO) {
          quantityButtons = `<button 
              type='button' 
              class='decrease medium absolute top-[50%] left-1 z-3 flex h-6 w-6 translate-y-[-50%] items-center justify-center disabled:opacity-50'
              onclick='subQty(${productId}, ${quantity}, ${planId})'
            >
              -
            </button>
            <button 
              type='button' 
              class='increase medium absolute top-[50%] right-1 z-3 flex h-6 w-6 translate-y-[-50%] items-center justify-center disabled:opacity-50'
              onclick='addQty(${productId}, ${quantity}, ${planId})'
            >
              +
            </button>`;
        }
        cartItemHTML = replaceAll(cartItemHTML, '%QUANTITY_BUTTONS%', quantityButtons);
        
        // Quantity disabled class for BOGO
        const quantityDisabled = isBOGO ? 'pointer-events-none' : '';
        cartItemHTML = replaceAll(cartItemHTML, '%QUANTITY_DISABLED%', quantityDisabled);
        
        // Quantity opacity for BOGO items
        const quantityOpacity = isBOGO ? 'opacity-50' : '';
        cartItemHTML = replaceAll(cartItemHTML, '%QUANTITY_OPACITY%', quantityOpacity);
        
        // Variant title
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' 
          ? `<p class='text-12 text-gray-medium leading-[1.2]'>${item.variant_title}</p>` 
          : '';
        cartItemHTML = replaceAll(cartItemHTML, '%VARIANT_TITLE%', variantTitle);
        
        // Selling plan (old format - hidden when we have %SELLING_PLAN_TEXT%)
        // Hide the old format since we now show it above with discount info
        const planHTML = ''; // Always empty now, using %SELLING_PLAN_TEXT% instead
        cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_PLAN%', planHTML);
        
        cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_ID%', item.id);
        cartItemHTML = replaceAll(cartItemHTML, '%PRODUCT_PLAN_ID%', sellingPlanId || 'null');
        
        cartItemHolder.insertAdjacentHTML('beforeend', cartItemHTML);
      });
      
      // Update checkout button
      const checkoutButton = document.querySelector('[name="checkout"]');
      if (checkoutButton) {
        checkoutButton.disabled = false;
      }
    }

    // Update cart count
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      if (cart.item_count > 0) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = 'flex';
      } else {
        cartCount.style.display = 'none';
      }
    }

    // Update subtotal
    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Update discount section (if Shopify discount is applied)
    const discountSection = document.querySelector('[data-cart-discounts]');
    if (cart.total_discount > 0) {
      if (!discountSection) {
        const subtotalDiv = document.querySelector('#cart-subtotal').parentElement.parentElement;
        const discountHTML = `
          <div class="bold flex gap-2 text-gray-600 text-sm justify-between mt-4 pt-4 border-gray-light border-t" data-cart-discounts>
            <p>
              <svg class="relative top-[-1px] inline-block h-3 w-3" viewBox="0 0 12 12">
                <title>Discount</title>
                <path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path>
              </svg>
              Total Savings
            </p>
            <p class="text-green">${formatMoney(cart.total_discount)}</p>
          </div>
        `;
        subtotalDiv.insertAdjacentHTML('beforeend', discountHTML);
      } else {
        const savingsEl = discountSection.querySelector('.text-green');
        if (savingsEl) {
          savingsEl.textContent = formatMoney(cart.total_discount);
        }
      }
    } else {
      if (discountSection) {
        discountSection.remove();
      }
    }
  }

  // Add to Cart
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .catch(error => console.error('Error adding to cart:', error));
  }

  // Remove from Cart
  function removeCart(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .catch(error => console.error('Error removing from cart:', error));
  }

  // Change Item Quantity
  function changeItem(productId, quantity, sellingPlanId = null) {
    if (quantity > 8) {
      quantity = 8;
    }
    
    // Normalize sellingPlanId
    if (sellingPlanId === 'null' || sellingPlanId === 'undefined' || sellingPlanId === '') {
      sellingPlanId = null;
    }

    // Add loading state to items container only
    const cartItemsContainer = document.getElementById('cart-items-container');
    if (cartItemsContainer) {
      cartItemsContainer.classList.add('loading');
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let line = null;

        // Find the FIRST matching item
        for (let index = 0; index < cart.items.length; index++) {
          const item = cart.items[index];
          
          if (item.id === productId) {
            const itemHasSellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
            const itemSellingPlanId = itemHasSellingPlan ? item.selling_plan_allocation.selling_plan.id : null;
            
            const plansMatch = (sellingPlanId === null && itemSellingPlanId === null) || 
                              (sellingPlanId !== null && itemSellingPlanId === sellingPlanId);
            
            if (plansMatch) {
              line = index + 1;
              break;
            }
          }
        }

        if (line !== null) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              quantity: quantity,
              line: line
            })
          });
        }
      })
      .then(response => response.json())
      .then(cart => {
        renderCart(cart);
      })
      .catch(error => console.error('Error changing item:', error))
      .finally(() => {
        // Remove loading state from items container
        if (cartItemsContainer) {
          cartItemsContainer.classList.remove('loading');
        }
      });
  }

  // Add Quantity
  function addQty(productId, quantity, sellingPlanId = null) {
    const newQuantity = Math.min(quantity + 1, 8);
    changeItem(productId, newQuantity, sellingPlanId);
  }

  // Subtract Quantity
  function subQty(productId, quantity, sellingPlanId = null) {
    const newQuantity = Math.max(quantity - 1, 0);
    changeItem(productId, newQuantity, sellingPlanId);
  }

  // Initialize Cart Events
  function initCart() {
    // Cart drawer close button
    const closeButton = document.querySelector('[data-cart-drawer-close]');
    if (closeButton) {
      closeButton.addEventListener('click', closeCart);
    }

    // Cart overlay
    const overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', closeCart);
    }

    // Cart open triggers
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open]')) {
        e.preventDefault();
        openCart();
      }
    });

    // ESC key to close cart
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        closeCart();
      }
    });
  }

  // Handle Product Form Submissions
  function handleProductForms() {
    document.addEventListener('submit', async (e) => {
      if (e.target.matches('form[action*="/cart/add"]')) {
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);
        const submitButton = form.querySelector('[data-product-form-btn]');
        const sectionId = submitButton ? submitButton.getAttribute('data-section-id') : null;
        
        // Show loading state
        if (submitButton) {
          submitButton.classList.add('loading');
          submitButton.disabled = true;
        }
        
        try {
          // Get quantity from form - check multiple sources
          let quantity = 1; // Default quantity
          let freeQuantity = 0;
          
          // 1. First, try to get from quantity-selector input (data-quantity-input)
          // This is the most reliable source as it reflects user's current selection
          // Check both inside the form AND in the parent element (product-box-v2 has it outside)
          let quantityInput = form.querySelector('[data-quantity-input]');
          
          // If not found inside form, check in parent container (for product-box-v2)
          if (!quantityInput) {
            const productBox = form.closest('[data-product-box]');
            if (productBox) {
              quantityInput = productBox.querySelector('[data-quantity-input]');
            }
          }
          
          if (quantityInput) {
            const qtyValue = parseInt(quantityInput.value);
            if (qtyValue && qtyValue > 0) {
              quantity = qtyValue;
            }
          }
          
          // 2. If still not found or is 1, try to get from formData (input hidden)
          if (quantity === 1) {
            const formQuantity = formData.get('quantity');
            if (formQuantity && parseInt(formQuantity) > 1) {
              quantity = parseInt(formQuantity) || 1;
            }
          }
          
          // 3. Try to find section by sectionId first (for BOGO sections)
          let section = null;
          if (sectionId) {
            section = document.getElementById(sectionId);
          }
          
          // If not found, try to find section by form's closest section or parent
          if (!section) {
            section = form.closest('section');
          }
          
          // If still not found, try to find by form ID (for CBD/THC sections)
          if (!section && form.id) {
            if (form.id.includes('cbd')) {
              section = document.getElementById('cbd-product-section');
            } else if (form.id.includes('thc')) {
              section = document.getElementById('thc-product-section');
            }
          }
          
          // 4. Check for BOGO quantity input in section (for BOGO forms)
          if (section) {
            const qtyInput = section.querySelector('.qty-input');
            if (qtyInput) {
              const sectionQty = parseInt(qtyInput.value) || 1;
              quantity = sectionQty;
              freeQuantity = sectionQty; // BOGO: same quantity for free items
            }
          }
          
          // Ensure quantity is at least 1
          if (quantity < 1) {
            quantity = 1;
          }
          
          // Get variant ID and selling plan
          const variantId = formData.get('id');
          let sellingPlan = formData.get('selling_plan');
          
          // If not in formData, try to get from checked radio in parent (for product-box-v2)
          if (!sellingPlan || sellingPlan === '') {
            const productBox = form.closest('[data-product-box]');
            if (productBox) {
              const checkedSNS = productBox.querySelector('input[name="selling_plan"]:checked');
              if (checkedSNS) {
                sellingPlan = checkedSNS.value;
              }
            }
          }
          
          // Check if selling_plan is empty string or null (one-time purchase)
          if (sellingPlan === '' || sellingPlan === null || sellingPlan === 'null') {
            sellingPlan = null;
          }
          
          
          // Validate selling_plan format (should be numeric ID)
          if (sellingPlan && typeof sellingPlan === 'string') {
            // If it starts with "gid://", extract just the numeric ID
            if (sellingPlan.includes('gid://')) {
              const matches = sellingPlan.match(/\d+$/);
              if (matches) {
                sellingPlan = parseInt(matches[0]);
              }
            } else {
              // Try to parse as integer
              const numericPlan = parseInt(sellingPlan);
              if (!isNaN(numericPlan)) {
                sellingPlan = numericPlan;
              }
            }
          }
          
          // Prepare items array for BOGO
          const items = [];
          
          // Add main product with quantity
          items.push({
            id: variantId,
            quantity: quantity,
            ...(sellingPlan && { selling_plan: sellingPlan })
          });
          
          // Add free items (BOGO) - same variant, same quantity, no selling plan (free items are usually one-time)
          if (freeQuantity > 0) {
            items.push({
              id: variantId,
              quantity: freeQuantity
              // Note: Free items typically don't have selling plans
            });
          }
          
          // Use items array if we have BOGO, otherwise use formData with quantity
          let requestBody;
          let headers = {};
          
          if (freeQuantity > 0 && items.length > 1) {
            // BOGO: use items array
            requestBody = JSON.stringify({ items: items });
            headers['Content-Type'] = 'application/json';
          } else {
            // Regular add to cart: ensure quantity is in formData and updated
            // Remove existing quantity if present, then add the correct one
            if (formData.has('quantity')) {
              formData.delete('quantity');
            }
            formData.append('quantity', quantity);
            
            // Remove selling_plan_frequency if present (not supported by Shopify)
            if (formData.has('selling_plan_frequency')) {
              formData.delete('selling_plan_frequency');
            }
            
            // Remove selling_plan if it's empty string (Shopify doesn't accept empty string)
            if (formData.has('selling_plan')) {
              const planValue = formData.get('selling_plan');
              if (planValue === '' || planValue === 'null' || planValue === null) {
                formData.delete('selling_plan');
              }
            }
            
            // Also update the hidden input in the form if it exists
            const hiddenQtyInput = form.querySelector('input[name="quantity"][type="hidden"]');
            if (hiddenQtyInput) {
              hiddenQtyInput.value = quantity;
            }
            
            // Create clean FormData with only required fields
            const cleanFormData = new FormData();
            cleanFormData.append('id', variantId);
            cleanFormData.append('quantity', quantity);
            
            // Only add selling_plan if it has a valid value
            if (sellingPlan && sellingPlan !== '' && sellingPlan !== 'null') {
              cleanFormData.append('selling_plan', sellingPlan);
            }
            
            requestBody = cleanFormData;
          }
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: headers,
            body: requestBody
          });
          
          if (response.ok) {
            // Small delay to show loading animation
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Open cart drawer after adding item
            openCart();
          } else {
            const errorData = await response.json().catch(() => ({}));
            console.error('Error adding to cart:', errorData);
            alert(errorData.description || errorData.message || 'Error adding product to cart');
          }
        } catch (error) {
          console.error('Error:', error);
          alert('Error adding product to cart');
        } finally {
          // Remove loading state
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.disabled = false;
          }
        }
      }
    });
  }

  // Initialize Cart on DOM Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCart();
      handleProductForms();
    });
  } else {
    initCart();
    handleProductForms();
  }


  // Export functions to global scope
  window.openCart = openCart;
  window.closeCart = closeCart;
  window.fetchCart = fetchCart;
  window.addToCart = addToCart;
  window.removeCart = removeCart;
  window.changeItem = changeItem;
  window.addQty = addQty;
  window.subQty = subQty;

  // Open cart drawer when cart icon is clicked
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Close cart drawer when close button is clicked
  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

  // Close on overlay click
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isCartOpen) {
      closeCartDrawer();
    }
  });

  // Check URL parameter to auto-open cart
  function checkOpenCartParam() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('open-cart') === 'true') {
      // Small delay to ensure cart is fully initialized
      setTimeout(function() {
        openCartDrawer();
        
        // Optionally remove the parameter from URL without reload
        const newUrl = new URL(window.location);
        newUrl.searchParams.delete('open-cart');
        window.history.replaceState({}, '', newUrl);
      }, 300);
    }
  }

  // Initialize auto-open cart check on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOpenCartParam);
  } else {
    checkOpenCartParam();
  }

  // AJAX Cart Update - Update quantity
  // Uses event delegation to work with dynamic content
  document.addEventListener('click', function(e) {
    const updateButton = e.target.closest('[data-cart-update]');
    if (updateButton) {
      e.preventDefault();
      const line = updateButton.dataset.line;
      const quantity = parseInt(updateButton.dataset.quantity);
      
      // Validate quantity (must be >= 0, but 0 should use remove instead)
      if (isNaN(quantity) || quantity < 0) return;
      
      // Find the cart item container and apply opacity
      const cartItem = document.querySelector(`[data-cart-item-key="${line}"]`);
      if (cartItem) {
        cartItem.style.opacity = '0.5';
        cartItem.style.pointerEvents = 'none';
      }
      
      // If quantity is 0, remove the item instead
      if (quantity === 0) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: line,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(cart => {
          updateCartContent();
        })
        .catch(error => {
          console.error('Error removing item:', error);
          // Restore opacity on error
          if (cartItem) {
            cartItem.style.opacity = '1';
            cartItem.style.pointerEvents = 'auto';
          }
        });
        return;
      }
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: line,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        updateCartContent();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        // Restore opacity on error
        if (cartItem) {
          cartItem.style.opacity = '1';
          cartItem.style.pointerEvents = 'auto';
        }
      });
    }
  });

  // AJAX Cart Remove - Remove item
  // Uses event delegation to work with dynamic content
  document.addEventListener('click', function(e) {
    const removeButton = e.target.closest('[data-cart-remove]');
    if (removeButton) {
      e.preventDefault();
      const line = removeButton.dataset.line;
      
      // Find the cart item container and apply opacity
      const cartItem = document.querySelector(`[data-cart-item-key="${line}"]`);
      if (cartItem) {
        cartItem.style.opacity = '0.5';
        cartItem.style.pointerEvents = 'none';
      }
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: line,
          quantity: 0
        })
      })
      .then(response => response.json())
      .then(cart => {
        updateCartContent();
      })
      .catch(error => {
        console.error('Error removing item:', error);
        // Restore opacity on error
        if (cartItem) {
          cartItem.style.opacity = '1';
          cartItem.style.pointerEvents = 'auto';
        }
      });
    }
  });
}


// Initialize Best Sellers Carousel
function initBestSellersCarousel() {
	'use strict';

	// Function to ensure jQuery is available
	function ensureJQuery(callback) {
		function tryInit() {
			if (typeof jQuery !== 'undefined') {
				callback(jQuery);
				return true;
			} else if (typeof $ !== 'undefined' && $.fn && $.fn.jquery) {
				callback($);
				return true;
			}
			return false;
		}
		
		if (!tryInit()) {
			// Load jQuery if not available
			if (typeof jQuery === 'undefined' && typeof $ === 'undefined') {
				var script = document.createElement('script');
				script.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
				script.integrity = 'sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo=';
				script.crossOrigin = 'anonymous';
				document.head.appendChild(script);
			}
			
			// Wait for jQuery to load
			var checkInterval = setInterval(function() {
				if (tryInit()) {
					clearInterval(checkInterval);
				}
			}, 50);
			
			// Timeout after 5 seconds
			setTimeout(function() {
				clearInterval(checkInterval);
				if (!tryInit()) {
					console.warn('jQuery was not loaded for best-sellers carousel');
				}
			}, 5000);
		}
	}

	function initBestSellersCarouselLogic($) {
		var $carousel = $('.bestsellers-carousel');
		var $wrapper = $('.bestsellers-carousel-wrapper');
		var $container = $('.bestsellers-carousel-container');
		var $progress = $('.bestsellers-progress');
		
		if ($carousel.length === 0 || $wrapper.length === 0) {
			return;
		}

		// Responsive settings (exactly like Swiper)
		var breakpoints = {
			default: { slidesPerView: 1.1, spaceBetween: 15 },
			575: { slidesPerView: 1.5, spaceBetween: 15 },
			767: { slidesPerView: 2, spaceBetween: 20 },
			1200: { slidesPerView: 2.5, spaceBetween: 25 },
			1440: { slidesPerView: 3, spaceBetween: 30 }
		};

		// Function to get current configuration based on screen width
		function getCurrentConfig() {
			var width = $(window).width();
			if (width >= 1440) return breakpoints[1440];
			if (width >= 1200) return breakpoints[1200];
			if (width >= 767) return breakpoints[767];
			if (width >= 575) return breakpoints[575];
			return breakpoints.default;
		}

		// Function to calculate slide width
		function calculateSlideWidth() {
			var config = getCurrentConfig();
			// Get container width (which has the correct width)
			var containerWidth = $container.width();
			// If not possible, try wrapper or parent
			if (!containerWidth || containerWidth === 0) {
				containerWidth = $wrapper.width() || $container.parent().width() || $(window).width();
			}
			var spaceBetween = config.spaceBetween;
			var slidesPerView = config.slidesPerView;
			
			// Calculate width of each slide
			var totalSpaces = (slidesPerView - 1) * spaceBetween;
			var slideWidth = (containerWidth - totalSpaces) / slidesPerView;
			
			return {
				slideWidth: slideWidth,
				spaceBetween: spaceBetween,
				slidesPerView: slidesPerView
			};
		}

		// Apply styles to slides
		function updateSlides() {
			var calc = calculateSlideWidth();
			var $slides = $carousel.find('.bestsellers-slide');
			
			$slides.css({
				'width': calc.slideWidth + 'px',
				'flex-shrink': '0'
			});
			
			// Apply margin-right to all except the last one
			$slides.not(':last-child').css('margin-right', calc.spaceBetween + 'px');
			$slides.last().css('margin-right', '0');

			// Update total carousel width
			var totalWidth = ($slides.length * calc.slideWidth) + (($slides.length - 1) * calc.spaceBetween);
			$carousel.css('width', totalWidth + 'px');
			
			// Update progressbar
			updateProgressbar();
		}

		// Update progressbar
		function updateProgressbar() {
			var scrollLeft = $wrapper.scrollLeft();
			var scrollWidth = $carousel[0].scrollWidth;
			var clientWidth = $wrapper[0].clientWidth;
			var scrollable = scrollWidth - clientWidth;
			
			if (scrollable > 0) {
				var progress = Math.min(100, (scrollLeft / scrollable) * 100);
				$progress.css('width', progress + '%');
			} else {
				$progress.css('width', '100%');
			}
		}

		// Configure carousel
		$carousel.css({
			'display': 'flex',
			'transition': 'transform 0.3s ease'
		});

		// Ensure wrapper has 100% width
		$wrapper.css({
			'width': '100%',
			'overflow-x': 'auto',
			'overflow-y': 'hidden',
			'scroll-behavior': 'smooth',
			'-webkit-overflow-scrolling': 'touch'
		});

		// Mousewheel horizontal (forceToAxis: true - horizontal axis only)
		var isScrolling = false;
		var lastWheelTime = 0;
		
		$wrapper.on('wheel', function(e) {
			var originalEvent = e.originalEvent || e;
			var deltaY = originalEvent.deltaY;
			var deltaX = originalEvent.deltaX;
			
			// If there's vertical movement, convert to horizontal
			if (Math.abs(deltaY) > Math.abs(deltaX) && deltaY !== 0) {
				e.preventDefault();
				e.stopPropagation();
				
				var now = Date.now();
				if (now - lastWheelTime < 16) return; // Throttle to ~60fps
				lastWheelTime = now;
				
				if (!isScrolling) {
					isScrolling = true;
					var scrollAmount = deltaY * 0.5; // Scroll speed
					
					$wrapper[0].scrollBy({
						left: scrollAmount,
						behavior: 'auto'
					});
					
					setTimeout(function() {
						isScrolling = false;
					}, 50);
				}
			}
		});

		// Update progressbar on scroll
		$wrapper.on('scroll', function() {
			updateProgressbar();
		});

		// Wait one frame to ensure layout is rendered
		setTimeout(function() {
			updateSlides();
		}, 0);

		// Update on resize
		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				updateSlides();
			}, 100);
		});
		
		// Update when images load (may change size)
		$carousel.find('img').on('load', function() {
			setTimeout(function() {
				updateSlides();
			}, 50);
		});
	}

	// Initialize when jQuery is ready
	ensureJQuery(function($) {
		if (document.readyState === 'loading') {
			$(document).ready(function() {
				initBestSellersCarouselLogic($);
			});
		} else {
			initBestSellersCarouselLogic($);
		}
	});
}

// Initialize Testimonials Swiper
function initTestimonialsSwiper(retryCount) {
	retryCount = retryCount || 0;
	const maxRetries = 20; // Maximum of 2 seconds (20 * 100ms)

	// Check if Swiper is available
	if (typeof Swiper === 'undefined') {
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 100);
		}
		return;
	}

	const testimonialsSwiper = document.querySelector('.testimonials-swiper');
	if (!testimonialsSwiper) {
		// Try again after a delay if element doesn't exist yet
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 100);
		}
		return;
	}

	// Check if already initialized
	if (testimonialsSwiper.swiper) {
		return;
	}

	// Find pagination element - try multiple strategies
	let paginationEl = testimonialsSwiper.parentElement?.querySelector('.testimonials-pagination');
	if (!paginationEl) {
		paginationEl = testimonialsSwiper.closest('.relative')?.querySelector('.testimonials-pagination');
	}
	if (!paginationEl) {
		paginationEl = document.querySelector('.testimonials-pagination');
	}
	
	if (!paginationEl) {
		// Try again if pagination was not found
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 100);
		}
		return;
	}

	let activeSlideIndex = 0;
	let swiperInstance = null;

	function updateThumbnails() {
		const section = testimonialsSwiper.closest('section');
		if (!section) return;
		
		const colorTheme = section.dataset.colorTheme || '#6E886E';
		const thumbs = section.querySelectorAll('.testimonial-thumb');
		
		if (thumbs.length === 0) return;
		
		thumbs.forEach(function(thumb, index) {
			if (index === activeSlideIndex) {
				thumb.classList.add('scale-110');
				thumb.style.borderColor = colorTheme;
				thumb.style.opacity = '1';
			} else {
				thumb.classList.remove('scale-110');
				thumb.style.borderColor = '';
				thumb.style.opacity = '0.6';
			}
		});
	}

	try {
		swiperInstance = new Swiper(testimonialsSwiper, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			spaceBetween: 0,
			slidesPerView: 1,
			allowTouchMove: false,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			},
			pagination: {
				el: paginationEl,
				clickable: true,
				renderBullet: function(index, className) {
					return '<span class="' + className + '" style="background-color: #000; opacity: 0.25; width: 0.45rem; min-width: 0.45rem; height: 0.45rem; margin: 0; padding: 0; cursor: pointer;"></span>';
				}
			},
			on: {
				init: function() {
					updateThumbnails();
				},
				slideChange: function(swiper) {
					activeSlideIndex = swiper.activeIndex;
					updateThumbnails();
				}
			}
		});

		// Make goToTestimonialSlide available globally
		window.goToTestimonialSlide = function(index) {
			if (swiperInstance) {
				swiperInstance.slideTo(index);
			}
		};
	} catch (error) {
		console.error('Error initializing testimonials swiper:', error);
		// Try again on error
		if (retryCount < maxRetries) {
			setTimeout(function() {
				initTestimonialsSwiper(retryCount + 1);
			}, 200);
		}
	}
}

// Initialize Product NFP Swiper
function initProductNFPSwiper() {
	const productNFPSwiper = document.querySelector('.product-nfp-swiper');
	if (productNFPSwiper && !productNFPSwiper.swiper) {
		if (typeof Swiper === 'undefined') {
			setTimeout(initProductNFPSwiper, 100);
			return;
		}

		const swiper = new Swiper(productNFPSwiper, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			spaceBetween: 0,
			slidesPerView: 1,
			pagination: {
				el: '.product-nfp-pagination',
				clickable: true,
				renderBullet: function(index, className) {
					return '<span class="' + className + '" style="background-color: #000; opacity: 0.25; width: 0.45rem; min-width: 0.45rem; height: 0.45rem; margin: 0; padding: 0; cursor: pointer;"></span>';
				}
			}
		});
	}
}

// Initialize Product Block Swiper (THC and CBD Gummies)
function initProductBlockSwiper() {
	// Check if Swiper is available
	if (typeof Swiper === 'undefined') {
		setTimeout(initProductBlockSwiper, 100);
		return;
	}

	// Find all product block swipers (both THC and CBD)
	const productBlockSwipers = document.querySelectorAll('.swiper.swiper-fade');
	
	productBlockSwipers.forEach(function(swiperEl) {
		// Skip if already initialized
		if (swiperEl.swiper) {
			return;
		}

		// Find pagination element - look for the element with swiper-pagination classes
		let paginationEl = null;
		
		// Try to find pagination in the parent container
		const parentContainer = swiperEl.closest('.relative');
		if (parentContainer) {
			paginationEl = parentContainer.querySelector('.swiper-pagination-clickable');
		}
		
		// If not found, try to find it by class
		if (!paginationEl) {
			paginationEl = swiperEl.parentElement?.querySelector('.swiper-pagination-clickable');
		}

		// Initialize swiper
		try {
			const swiperInstance = new Swiper(swiperEl, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				spaceBetween: 0,
				slidesPerView: 1,
				allowTouchMove: true,
				pagination: paginationEl ? {
					el: paginationEl,
					clickable: true,
					renderBullet: function(index, className) {
						return '<span class="' + className + '"></span>';
					}
				} : false
			});
		} catch (error) {
			console.warn('Error initializing product block swiper:', error);
		}
	});
}

// init magnetic buttons
function initMagneticButtons() {
	const buttons = document.querySelectorAll('.magnetic-button')

	buttons.forEach((button) => {
		// prevent double init
		if (button.dataset.gsapInit === 'true') return
		button.dataset.gsapInit = 'true'

		// allow the effect on desktop only
		if (window.innerWidth <= 540) return

		const strength = parseFloat(button.dataset.strength) || 50

		let bounding = null
		let rafId = null

		// cache bounding rect
		const updateBounding = () => {
			bounding = button.getBoundingClientRect()
		}

		// throttle bounding rect updates with RAF
		const throttledUpdateBounding = () => {
			if (rafId) return
			rafId = requestAnimationFrame(() => {
				updateBounding()
				rafId = null
			})
		}

		// initial bounding rect
		updateBounding()

		function moveMagnet(event) {
			if (!bounding) return

			const x =
				((event.clientX - bounding.left) / bounding.width - 0.5) *
				strength

			const y =
				((event.clientY - bounding.top) / bounding.height - 0.5) *
				strength

			gsap.to(button, {
				x,
				y,
				rotate: '0.001deg', // forces GPU rendering
				ease: 'power4.out',
				duration: 1.5
			})
		}

		function resetMagnet() {
			gsap.to(button, {
				x: 0,
				y: 0,
				ease: 'elastic.out(1, 0.4)',
				duration: 1.5
			})
		}

		button.addEventListener('mousemove', moveMagnet)
		button.addEventListener('mouseleave', resetMagnet)
		window.addEventListener('resize', throttledUpdateBounding, { passive: true })
		window.addEventListener('scroll', throttledUpdateBounding, { passive: true })
	})
}

// Initialize Contact Form
/*
function initContactForm() {
	var form = document.querySelector('.contact-form');
	if (!form) return;

	var submitButton = form.querySelector('[data-form-submit]');
	
	form.addEventListener('submit', function(e) {
		if (submitButton) {
			submitButton.disabled = true;
			submitButton.textContent = 'Sending...';
		}
	});

	// Re-enable button if form has errors (Shopify will reload page)
	if (form.querySelector('.form-error-message') && submitButton) {
		submitButton.disabled = false;
		submitButton.textContent = 'Send Message';
	}
}
*/

// init accordion (snippets/accordion.liquid)
function initAccordions() {
	const accordionItems = document.querySelectorAll('.faq-accordion-item')

	accordionItems.forEach((item) => {
		const button = item.querySelector('.faq-accordion-button')
		if (!button) return

		button.addEventListener('click', () => {
			item.classList.toggle('active')
		})
	})

  const categoriesAccordion = document.querySelectorAll('.collections-nav')

  categoriesAccordion.forEach((item) => {
		const button = item.querySelector('.open-categories')
		if (!button) return

		button.addEventListener('click', () => {
			item.classList.toggle('active')
		})
	})
}

// init scrolling images (snippets/scrolling-image.liquid)
function initScrollingImages() {
	const scrollingImages = document.querySelectorAll('.scrolling-image')

	scrollingImages.forEach((wrapper) => {
		if (wrapper.dataset.gsapInit === 'true') return
		wrapper.dataset.gsapInit = 'true'

		const container = wrapper.closest('.scrolling-image-container')
		const image = wrapper.querySelector('img')

		if (!container || !image) return

		const isDesktop = window.innerWidth > 768
		const calcSize = isDesktop
			? 'calc(100% + 7rem)'
			: 'calc(100% + 3rem)'
		const offset = isDesktop ? '-7rem' : '-3rem'

		gsap.set(image, {
			height: calcSize,
			display: 'block'
		})

		gsap.from(image, {
			y: offset,
			scrollTrigger: {
				trigger: container,
				scrub: 3,
				start: 'top bottom',
				end: 'bottom top',
				//markers: true
			}
		})
	})
}

// init image reveal (snippets/image-reveal.liquid)
function initImageReveal() {
	const reveals = document.querySelectorAll('.image-reveal')

	reveals.forEach((container) => {
		if (container.dataset.gsapInit === 'true') return
		container.dataset.gsapInit = 'true'

		const overlay = container.querySelector('.image-reveal__overlay')
		const image = container.querySelector('.image-reveal__image')

		if (!overlay || !image) return

		const timeline = gsap.timeline({ paused: true })

		timeline.set(image, {
			scale: 1.5
		})

		timeline.to(overlay, {
			width: '100%',
			ease: 'power4.inOut',
			duration: 0.75
		})

		timeline.to(overlay, {
			x: '100%',
			ease: 'power4.in',
			duration: 1
		})

		timeline.to(
			image,
			{
				visibility: 'visible',
				scale: 1,
				duration: 2.5,
				ease: 'power4.out'
			},
			'-=1'
		)

		ScrollTrigger.create({
			trigger: container,
			start: '0% 120%',
			end: '100% -20%',
			onEnter: () => timeline.play(),
			onLeaveBack: () => timeline.reverse(),
			//markers: true
		})
	})
}

// init stagger up
function initStaggerUp() {
	const staggerContainers = document.querySelectorAll('.stagger-up')

	staggerContainers.forEach((container) => {
		// prevent double init
		if (container.dataset.gsapInit === 'true') return
		container.dataset.gsapInit = 'true'

		const children = Array.from(container.children)
		if (!children.length) return

		const infinite = container.dataset.infinite === 'true'

		// initial state
		gsap.set(children, {
			opacity: 0,
			y: '20vh'
		})

		ScrollTrigger.batch(children, {
			start: '-50% 100%',
			onEnter: (elements) => {
				gsap.to(elements, {
					opacity: 1,
					y: 0,
					stagger: 0.15,
					duration: 0.5,
					ease: 'power2.out'
				})
			},
			...(infinite && {
				onLeaveBack: (elements) => {
					gsap.to(elements, {
						opacity: 0,
						y: '20vh',
						stagger: 0.15,
						duration: 0.5,
						ease: 'power2.in'
					})
				}
			})
		})
	})
}

// init animated counter
function initCounters() {
	const counters = document.querySelectorAll('.counter-number')

	counters.forEach((counter) => {
		// prevent double init
		if (counter.dataset.gsapInit === 'true') return
		counter.dataset.gsapInit = 'true'

		const finalValue = parseInt(counter.textContent.replace(/,/g, ''), 10)
		if (isNaN(finalValue)) return

		gsap.from(counter, {
			textContent: 0,
			duration: 3,
			ease: 'power2.inOut',
			modifiers: {
				textContent: (value) => Math.floor(value)
			},
			scrollTrigger: {
				trigger: counter,
				start: 'top 90%',
				toggleActions: 'play none none none',
				//markers: true
			}
		})
	})
}

// Initialize Banner Home Swiper
function initBannerHomeSwiper() {
	'use strict';
	
	// Check if Swiper is available
	if (typeof Swiper === 'undefined') {
		setTimeout(initBannerHomeSwiper, 100);
		return;
	}
	
	const bannerSwiperEl = document.querySelector('.banner-home-swiper');
	if (!bannerSwiperEl || bannerSwiperEl.swiper) {
		return;
	}
	
	// Initialize Swiper (without modules property - modules are included in bundle)
	try {
		const bannerSwiper = new Swiper('.banner-home-swiper', {
			spaceBetween: 0,
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			allowTouchMove: false,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.banner-pagination',
				clickable: true,
			},
			loop: true,
		});
	} catch (error) {
		console.error('Error initializing banner swiper:', error);
	}
	
	// Magnetic Button Effect for banner
	const magneticButtons = document.querySelectorAll('[data-magnetic]');
	
	if (window.innerWidth > 540) {
		magneticButtons.forEach(function(button) {
			// Prevent double initialization
			if (button.dataset.magneticInit === 'true') return;
			button.dataset.magneticInit = 'true';
			
			button.addEventListener('mousemove', function(e) {
				var rect = this.getBoundingClientRect();
				var x = ((e.clientX - rect.left) / rect.width - 0.5) * 50;
				var y = ((e.clientY - rect.top) / rect.height - 0.5) * 50;
				
				if (typeof gsap !== 'undefined') {
					gsap.to(this, {
						x: x,
						y: y,
						rotate: '0.001deg',
						ease: 'power4.out',
						duration: 1.5
					});
				}
			});
			
			button.addEventListener('mouseleave', function() {
				if (typeof gsap !== 'undefined') {
					gsap.to(this, {
						x: 0,
						y: 0,
						ease: 'elastic.out(1, 0.3)',
						duration: 1.5
					});
				}
			});
		});
	}
}

// Initialize Categories Stagger Animation
function initCategoriesStagger() {
	'use strict';
	
	// Check if GSAP and ScrollTrigger are available
	if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
		setTimeout(initCategoriesStagger, 100);
		return;
	}
	
	// Register ScrollTrigger plugin
	if (gsap.registerPlugin) {
		gsap.registerPlugin(ScrollTrigger);
	}
	
	const staggerContainers = document.querySelectorAll('[data-stagger]');
	
	if (staggerContainers.length === 0) {
		return;
	}
	
	staggerContainers.forEach((container) => {
		// Prevent double initialization
		if (container.dataset.gsapInit === 'true') return;
		container.dataset.gsapInit = 'true';
		
		const children = Array.from(container.children);
		if (!children.length) return;
		
		// Set initial state
		gsap.set(children, {
			opacity: 0,
			y: '20vh'
		});
		
		// Create batch animation
		ScrollTrigger.batch(children, {
			start: '-50% 100%',
			onEnter: function(elements) {
				gsap.to(elements, {
					opacity: 1,
					y: 0,
					stagger: 0.15,
					duration: 0.5,
					ease: 'power2.out'
				});
			}
		});
	});
}

// init format numbers to US format
function formatUS() {
  const numbers = document.querySelectorAll('.number-us-format')

  numbers.forEach((el) => {
    const value = Number(el.textContent.trim())

    if (!Number.isNaN(value)) {
      el.textContent = value.toLocaleString('en-US')
    }
  })
}

// Initialize Age Gateway
function initAgeGateway() {
	'use strict';
	
	const gateway = document.getElementById('age-gateway');
	if (!gateway) return;
	
	// Get settings from data attributes
	const cookieMaxAge = parseInt(gateway.dataset.cookieMaxAge) || 30;
	const declineRedirectUrl = gateway.dataset.declineRedirectUrl || 'https://google.com';
	//const gatewayEnabled = gateway.dataset.gatewayEnabled === 'true';
  const gatewayEnabled = true;

	// Don't show age gateway if disabled or on specific pages
	if (!gatewayEnabled || window.location.pathname === '/bogo') {
		return;
	}
	
	const AGE_GATE_COOKIE_NAME = 'age_gate_accepted';
	
	// Cookie helper functions
	function getCookie(name) {
		const value = '; ' + document.cookie;
		const parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
		return null;
	}
	
	function setCookie(name, value, days) {
		const expiresDate = new Date();
		expiresDate.setTime(expiresDate.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = 'expires=' + expiresDate.toUTCString();
		document.cookie = name + '=' + value + ';' + expires + ';path=/';
	}
	
	// Check if user has already accepted
	const hasAccepted = getCookie(AGE_GATE_COOKIE_NAME);
	
	if (!hasAccepted) {
		gateway.style.display = 'flex';
		document.body.style.overflow = 'hidden';
		
		// Handle accept button
		const acceptBtn = document.getElementById('age-gateway-accept');
		if (acceptBtn) {
			acceptBtn.addEventListener('click', function() {
				setCookie(AGE_GATE_COOKIE_NAME, 'true', cookieMaxAge);
				gateway.style.display = 'none';
				document.body.style.overflow = '';
			});
		}
		
		// Handle decline button
		const declineBtn = document.getElementById('age-gateway-decline');
		if (declineBtn) {
			declineBtn.addEventListener('click', function() {
				window.location.href = declineRedirectUrl;
			});
		}
		
		// Close on ESC key
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && gateway.style.display === 'flex') {
				// Don't allow closing without selection
				// gateway.style.display = 'none';
			}
		});
	}
}

function initNewProductBox() {
  
  /**
   * QUANTITY CONTROLS (+ / −)
   */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-action]');
    if (!btn) return;

    const productBox = btn.closest('[data-product-box]');
    if (!productBox) return;

    const input = productBox.querySelector('[data-quantity-input]');
    if (!input) return;

    const min = parseInt(input.min || 1, 10);
    const max = parseInt(input.max || 9999, 10);
    let value = parseInt(input.value || min, 10);

    if (btn.dataset.qtyAction === 'increment') {
      if (value < max) value += 1;
    }

    if (btn.dataset.qtyAction === 'decrement') {
      if (value > min) value -= 1;
    }

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /**
   * ADD TO CART (AJAX)
   */
  
  /*
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;

    e.preventDefault();

    const productBox = form.closest('[data-product-box]');
    const qtyInput = productBox?.querySelector('[data-quantity-input]');

    const button = form.querySelector('[data-product-form-btn]');
    const text = button.querySelector('.btn-text');
    const spinner = button.querySelector('.btn-icon-loading');

    if (button.classList.contains('loading')) return;

    button.classList.add('loading');
    button.disabled = true;

    if (text) text.style.display = 'none';
    if (spinner) spinner.classList.remove('hidden');

    const formData = new FormData(form);
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) throw new Error('Add to cart failed');

      const data = await res.json();

      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: data })
      );

    } catch (err) {
      console.error(err);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;

      if (text) text.style.display = '';
      if (spinner) spinner.classList.add('hidden');
    }
  });
  */
}

// init everything
function initScripts() {
  initNewProductBox()
	initSliders()
	initMobileMenu()
	initCartDrawer()
	initBestSellersCarousel()
	initTestimonialsSwiper()
	initProductNFPSwiper()
	initProductBlockSwiper()
	initBannerHomeSwiper()
	initCategoriesStagger()
	initAccordions()
	initScrollingImages()
	initMagneticButtons()
	//initContactForm()
	initImageReveal()
	initStaggerUp()
	initCounters()
	initAgeGateway()
  initFancybox()
  formatUS()
}

document.addEventListener("DOMContentLoaded", initScripts)
document.addEventListener("shopify:section:load", initScripts)